module.exports = __webpack_public_path__ + "img/stc.3111039d.svg";